import React from "react";

import css from "./tile.module.scss";

export const TileGroup = ({ children }: React.PropsWithChildren) => (
  <div className={css.tileGroup}>{children}</div>
);
